import { render, staticRenderFns } from "./PayWindow.vue?vue&type=template&id=6d8a311e&scoped=true"
import script from "./PayWindow.vue?vue&type=script&lang=js"
export * from "./PayWindow.vue?vue&type=script&lang=js"
import style0 from "./PayWindow.vue?vue&type=style&index=0&id=6d8a311e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a311e",
  null
  
)

export default component.exports